<template>
<div v-if="isShow">
    <div class="ws-toast" >
        <span>
             {{content}}
        </span>
    </div>
     <div class="mask rule-mask"></div>
</div>

</template>

<script>
import {imageMixin} from '@/mixins'
export default {
    name:'wsToast',
    mixins: [imageMixin],
    data(){
        return{
            isShow:false,
            content:'NetWork Error',
            delayClose:null
        }
    }
}
</script>
<style lang="scss" scoped>
.ws-toast{
    position: fixed;
    top: 50%;
    left: 50%;
    color: #fff;
    z-index: 34;
    text-align: center;
    @include res-size(
        $min-width:880px,
        $height:70px,
        $line-height:65px,
        $margin-left:-440px
    );
    background-size: 100% 100%;
    background-position-x: center;
    background-repeat: no-repeat;
    opacity:0.85;
    span{
        font-family: $font-family;
        opacity:1;
        @include res-size(
            $font-size: 30px
        );
    }
}
</style>


// WEBPACK FOOTER //
// src/components/wsToast/index.vue